import React from 'react';
import _ from 'lodash';

import { useThirdPartyAccountSelectFieldQuery } from 'generated/graphql';



export interface IThirdPartyAccount {
  id: string;
  displayName: string;
}

export interface IData {
  objects: IThirdPartyAccount[];
}

export function useQuery() {
  const queryTuple = useThirdPartyAccountSelectFieldQuery({
    variables: {}
  });

  const wrappedTuple = React.useMemo(() => {
    const data: IData = {
      objects: _.map(queryTuple.data?.thirdPartyAccounts.nodes ?? [], (node): IThirdPartyAccount => ({
        id: node.id,
        displayName: `${node.name} (${node.accountNumber})`
      }))
    };

    return {
      loading: queryTuple.loading,
      data,
      refetch: async () => {
        queryTuple.refetch({});
      }
    };
  }, [queryTuple]);

  return wrappedTuple;
}
